import { useQuery } from '@tanstack/react-query';

import type { AdminSystemHealth } from '../api/client';
import { useAdminAuth } from '../auth/AuthProvider';

export function SystemHealthPage() {
  const { fetcher } = useAdminAuth();
  const { data, isLoading, error } = useQuery({
    queryKey: ['admin', 'system', 'health'],
    queryFn: () => fetcher<AdminSystemHealth>('/admin/api/system/health'),
    refetchInterval: 15_000,
  });

  return (
    <div className="space-y-4">
      <h1 className="text-xl font-semibold">System health</h1>
      {isLoading ? <div>Loading…</div> : null}
      {error ? <div className="card text-red-600">{(error as Error).message}</div> : null}
      {data ? (
        <div className="card space-y-2">
          <div className="flex items-center gap-2">
            <span className="font-medium">Overall:</span>
            <span
              className={
                data.ok
                  ? 'badge bg-emerald-100 text-emerald-700'
                  : 'badge bg-red-100 text-red-700'
              }
            >
              {data.ok ? 'ok' : 'degraded'}
            </span>
          </div>
          <pre className="overflow-x-auto rounded bg-slate-100 p-3 text-xs">
            {JSON.stringify(data.checks, null, 2)}
          </pre>
        </div>
      ) : null}
    </div>
  );
}
